import type { ZodType } from 'zod';
import { unwrapList } from './client';

/** Validate either the canonical `{data: [...]}` envelope or a bare list. */
export function extractList<T>(response: unknown, itemSchema: ZodType<T>, label: string): T[] {
  return unwrapList(response, itemSchema, label);
}
